// 顧客メール本文の宛名トークンの付け外し。
//
// 宛名は自動付与しない方針（2026-07-25）なので、本文の先頭に
// `{{customer_salutation}}` があるかどうかが「宛名を出すか」の唯一の状態。
// チェックボックスの ON/OFF はこのトークンの付け外しに落とす（状態を二重に持たない）。
// 実際の置換（「〇〇 様」／連絡担当者名が空なら「ご担当者様」）は BE のレンダラが行う。

export const SALUTATION_TOKEN = "{{customer_salutation}}";

/** 本文に宛名トークンが含まれるか（＝チェックボックスの状態） */
export function hasSalutation(body: string): boolean {
  return (body || "").includes(SALUTATION_TOKEN);
}

/** 本文の先頭へ宛名トークンを付ける（既にあれば何もしない） */
export function withSalutation(body: string): string {
  if (hasSalutation(body)) return body;
  const rest = (body || "").replace(/^\n+/, "");
  return rest ? `${SALUTATION_TOKEN}\n\n${rest}` : `${SALUTATION_TOKEN}\n\n`;
}

/** 本文から宛名トークンを取り除く（行まるごと／文中どちらの書き方でも消す） */
export function withoutSalutation(body: string): string {
  const kept = (body || "")
    .split("\n")
    .filter((line) => line.trim() !== SALUTATION_TOKEN)
    .join("\n");
  // 行として書かれていない（文中に埋め込まれた）ぶんも落とす
  return kept.split(SALUTATION_TOKEN).join("").replace(/^\n+/, "");
}

/** チェックボックスの ON/OFF を本文へ反映する */
export function setSalutation(body: string, on: boolean): string {
  return on ? withSalutation(body) : withoutSalutation(body);
}
